const styleSheet = {
  checkHolder: {
    display: "flex",
    alignItems: "center",
    "& input": {
      fontSize: "14px",
      color: "#051D39",
      boxSizing: "border-box",
      height: "40px",
      width: "100%",
      padding: "0 10px",
      border: "1.2px solid #D8DCE6",
      borderRadius: "4px",
      backgroundColor: "#FFFFFF",
      "&::placeholder": {
        textOverflow: "ellipsis !important",
        color: "#B7C1E1"
      },
      "&:-ms-input-placeholder": {
        textOverflow: "ellipsis !important",
        color: "#B7C1E1"
      },
      "&:-webkit-input-placeholder": {
        textOverflow: "ellipsis !important",
        color: "#B7C1E1"
      }
    }
  },
  label: {
    width: "83px",
    height: "19px",
    color: "#6373A4",
    fontSize: "12px",
    letterSpacing: 0,
    lineHeight: "15px",
    marginLeft: "9px"
  },
  bottom: {
    paddingLeft: "22px",
    "& > div:first-child": {
      marginBottom: "5px"
    }
  },
  controls: {
    marginTop: "15px",
    display: "flex",
    justifyContent: "center",
    "& > *": {
      marginRight: "16px"
    },
    "& :last-child": {
      marginRight: 0
    }
  },
  loadingHolder: {
    marginTop: "33px",
    height: "100%",
    width: "100%",
    top: 0,
    left: 0,
    position: "absolute",
    display: "flex",
    alignItems: "center"
  },
  error: {
    color: "#FF6969",
    fontSize: "12px",
    letterSpacing: 0,
    paddingLeft: "10px",
    marginTop: "5px"
  }
};

export default styleSheet;
